
import { OnboardingStep } from './useOnboardingState';

interface AppInstallationProps {
  setStep: (step: OnboardingStep) => void;
}

export const useAppInstallation = ({ setStep }: AppInstallationProps) => {
  const handleInstallAppContinue = () => {
    // Mark the app as installed in localStorage
    localStorage.setItem('appInstalled', 'true');
    
    // Log success message
    console.log("Installation réussie! Merci d'avoir installé EasyDJ+");
    
    // Move to the next step
    setStep('info');
  };

  const handleInstallAppSkip = () => {
    // Skip the installation step
    setStep('info');
  };

  return {
    handleInstallAppContinue,
    handleInstallAppSkip
  };
};
